import topology from "../components/dma-map/topo.json";

type DmaInfo = {
  name?: string;
};

// Build a lightweight lookup of DMA code -> friendly name from the topojson metadata
export const dmaInfoMap: Record<string, DmaInfo> = (() => {
  const map: Record<string, DmaInfo> = {};
  const geometries =
    (topology as any)?.objects?.nielsen_dma?.geometries || [];

  geometries.forEach((geometry: any) => {
    const code = geometry?.properties?.dma;
    const name = geometry?.properties?.dma1 || geometry?.properties?.name;
    if (code) {
      map[String(code)] = { name };
    }
  });

  return map;
})();
